export default __webpack_public_path__ + "5eb1a69239058d51f54002a4abdd5949.png";